import React from "react";

export const NoDataIndication = () => (
    <div className="spinner">
        <div style={{paddingTop: "75.000%", position: "relative"}}>
            <h1 style={{position: "absolute", top: "30%", left: "40%"}}> No Data Found</h1>
        </div>
    </div>
);
